import React, { useEffect, useState } from "react";
import Edit_Risk_Opportunities from "./edit_Risk_Opportunities/Edit_Risk_Opportunities";
import Risk_Opportunities_Form from "./risk_Opportunities_Form/Risk_Opportunities_Form";
import Risk_Opportunities_table from "./risk_Opportunities_table/Risk_Opportunities_table";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/management_system/Slice";
import { useDispatch, useSelector } from "react-redux";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FixIDS } from "../../../../../../utils/fixIDS";

function Risk_Opportunities({
  managementdetails,
  setCurrentPage,
  currentPage,
}) {
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleEdit = (id) => {
    setEditId(id);
    setIsEdit(true);
  };

  const permissions = useSelector((state) => state.auth.permissions);
  const haveAddPermission = permissions?.includes(FixIDS.risk_and_opportunity.Add);
  const haveReadPermission = permissions?.includes(FixIDS.management_system.List);

  
  return (
    <section className="Imperiality">
      {isEdit ? (
        <>
         <div className="back_div">
            {/* <Common_Back_Btn backText="Edit risk opportunities" /> */}
          </div>
        <Edit_Risk_Opportunities
          managementsystemTypeId={3}
          id={editId}
          onCancel={() => {
            setIsEdit(false);
            setEditId(null);
          }}
        />
        </>
      ) : (
        <>
          <div className="imperiality_Form_div">
            { haveAddPermission && <Risk_Opportunities_Form managementsystemTypeId={3} />}
          </div>

          <div className="imperiality_table_div">
            { haveReadPermission && <Risk_Opportunities_table
              managementsystemTypeId={3}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              managementdetails={managementdetails}
              onEdit={handleEdit}
            />}
          </div>
        </>
      )}
    </section>
  );
}

export default Risk_Opportunities;
